import React, { useEffect, useState } from "react";
import PendingBookingCard from "./pendingBookingCard/PendingBookingCard";
import BookingCard from "./BookingCard/BookingCard";
import { fetchTableList } from "../../../../services/getTable";
import { useNavigate } from "react-router-dom";
import MyBooking from "./myBooking";

const Bookings = ({ otherProfile, userId, bookings }) => {
  const [tableList, setTableList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await fetchTableList({
          id: userId,
          page: 1,
          limit: 10,
        });
        setTableList(data.items);
      } catch (error) {
        // console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  const navigate = useNavigate();

  const handleNavigate = (name, id) => {
    const formattedName = name.replace(/\s+/g, "-"); // Replace spaces with dashes
    navigate(`/details?table=${encodeURIComponent(formattedName)}&id=${id}`);
  };

  return (
    <div
      data-w-tab="Tab 1"
      className="my-account-tab-content w-tab-pane w--tab-active"
    >
      <div className="w-layout-grid account-page-mytables">
        {/* {!otherProfile && (
          <button onClick={handlePayment} className="payment-button ">
            <PendingBookingCard />
          </button>
        )} */}
        {bookings ? (
          <>
            <MyBooking />
          </>
        ) : (
          <>
            {tableList.map((item, index) => (
              <div
                key={index}
                onClick={() => handleNavigate(item?.title, item.id)}
              >
                <BookingCard cardDetails={item} otherProfile={otherProfile} />
              </div>
            ))}
          </>
        )}
      </div>
      {tableList.length <= 0 && !loading && (
        <div className="download-app-div-float">Sorry no tables found</div>
      )}
    </div>
  );
};

export default Bookings;
